import { Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';

@Injectable()
export class LoggerService {

  constructor() { }

  static log(...params) {
    if (!environment.production) {
      console.log(...params);
    }
  }

}



// WEBPACK FOOTER //
// G:/UTL/Student/Student-ANG/src/app/services/logger/logger.service.ts